<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">new transporter truck</small>
      </legend>
      <div>
        <form @submit.prevent="newTruck()">
          <div class="row">
            <div class="col-md-6">
              <input type="hidden" class="transporter_id" :value="Transporter.id" />
              <div class="form-group">
                <label>Truck no</label>
                <input
                  type="text"
                  class="form-control truck_no input-rounded f-s-14"
                  placeholder="truck number plate"
                  required
                />
              </div>
              <div class="form-group">
                <label>Driver name</label>
                <input
                  type="text"
                  class="form-control driver_name input-rounded f-s-14"
                  placeholder="driver name"
                  required
                />
              </div>
              <div class="form-group">
                <label>Driver phone</label>
                <input
                  type="text"
                  class="form-control driver_phone input-rounded f-s-14"
                  placeholder="driver phone number"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Trailer no</label>
                <input
                  type="text"
                  class="form-control trailer_no input-rounded f-s-14"
                  placeholder="trailer number"
                  required
                />
              </div>
              <div class="form-group">
                <label>Driver Id number</label>
                <input
                  type="number"
                  class="form-control driver_id_number input-rounded f-s-14"
                  placeholder="driver id number"
                  required
                />
              </div>
              <div class="form-group">
                <label>Dl licence no</label>
                <input
                  type="text"
                  class="form-control dl_licence input-rounded f-s-14"
                  placeholder="driving licence number"
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingTruck btn-rounded">
            <i class="fa fa-truck"></i>Add Truck
          </button>
          <button type="button" class="btn btn-primary btn-flat creatingTruckLoader btn-rounded">
            <i class="fa fa-spinner fa-spin" style="font-size:24px;"></i>please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
import router from "../router";
export default {
  created() {
    if (this.$store.getters.Transporter.length === 0) {
      router.push("/managetransporters");
    }
  },
  computed: {
    ...mapGetters(["Transporter"])
  },
  methods: {
    ...mapActions(["newTruck"])
  }
};
</script>
<style scoped>
.creatingTruckLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/trucks/trucks.vue